import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';

export default class TheKeys extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
      text: (<div>The. KEYS</div>),
      text_plainText: "The. KEYS",
      textcopy: (<div>The Key grants to the mortals the unique possibility to keep those memories alive for the perpetuity, and only those with the key can eventually enter the Mnemosyne Metaverse to travel time and re-experience the moments back in time.</div>),
      textcopy_plainText: "The Key grants to the mortals the unique possibility to keep those memories alive for the perpetuity, and only those with the key can eventually enter the Mnemosyne Metaverse to travel time and re-experience the moments back in time.",
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const style_elBackground = {
      width: '100%',
      height: '100%',
     };
    const style_elBackground_outer = {
      boxSizing: 'border-box',
      backgroundColor: 'black',
     };
    const style_elText = {
      fontSize: 60.0,
      color: '#fffefe',
      textAlign: 'left',
     };
    const style_elTextCopy = {
      fontSize: 24.0,
      color: '#fffefe',
      textAlign: 'left',
     };
    
    return (
      <div className="TheKeys">
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div style={style_elBackground} />
          </div>
        </div>
        
        <div className="layoutFlow">
          <div className="elText">
            <div className="font-caesarDressingRegular" style={style_elText}>
              <div>{this.state.text}</div>
            </div>
          </div>
          
          <div className="elTextCopy">
            <div className="font-caesarDressingRegular" style={style_elTextCopy}>
              <div>{this.state.textcopy}</div>
            </div>
          </div>
        </div>
        
      </div>
    )
  }
  
}
